import { Product } from '../types'

export const products: Product[] = [
  // FLAGSHIP PRODUCT
  {
    id: 'pool-premium-frame-457',
    name: 'Каркасний басейн Premium Frame 4.57 м + комплект фільтрації',
    price: 29900,
    oldPrice: 34900,
    category: 'Басейни',
    categorySlug: 'basejny',
    image: 'https://images.unsplash.com/photo-1575429198097-0414ec08e8cd?w=800',
    images: [
      'https://images.unsplash.com/photo-1575429198097-0414ec08e8cd?w=800',
      'https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?w=800',
      'https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?w=800',
      'https://images.unsplash.com/photo-1519046904884-53103b34b206?w=800',
      'https://images.unsplash.com/photo-1562778612-e1e0cda9915c?w=800',
      'https://images.unsplash.com/photo-1572331165267-854da2b021aa?w=800',
    ],
    rating: 4.8,
    reviewCount: 24,
    inStock: true,
    badge: 'Хіт продажів',
    shortDesc:
      'Преміум каркасний басейн з повним комплектом фільтрації. Ідеальне рішення для дачі або приватного будинку.',
    description:
      'Каркасний басейн Premium Frame — це надійна конструкція з високоякісних матеріалів, що забезпечує довговічність та комфортне використання. У комплекті йде професійна система фільтрації води, що підтримує кристальну чистоту басейну протягом усього сезону. Тришаровий ПВХ матеріал стінок забезпечує міцність та стійкість до ультрафіолету. Сталевий каркас з антикорозійним покриттям гарантує стабільність конструкції навіть при повному заповненні водою.',
    characteristics: [
      { label: 'Діаметр', value: '4.57 м' },
      { label: 'Висота', value: '1.22 м' },
      { label: "Об'єм води", value: '16,805 л' },
      { label: 'Матеріал', value: 'ПВХ 3-шаровий' },
      { label: 'Каркас', value: 'Сталь з антикорозійним покриттям' },
      { label: 'Тип фільтрації', value: 'Картриджний фільтр-насос' },
      { label: 'Продуктивність насоса', value: '3,785 л/год' },
      { label: 'Товщина стінок', value: '0.55 мм' },
      { label: 'Товщина дна', value: '0.40 мм' },
      { label: 'Вага', value: '52 кг' },
      { label: 'Гарантія', value: '2 роки' },
      { label: 'Країна виробник', value: 'Китай (бренд США)' },
    ],
    crossSell: [
      'chemical-chlorine-5kg',
      'cover-round-460',
      'vacuum-cleaner',
      'test-kit',
    ],
  },
  // POOLS (Басейни)
  {
    id: 'pool-intex-366',
    name: 'Каркасний басейн Intex Prism Frame 3.66 м',
    price: 14500,
    oldPrice: 16900,
    category: 'Басейни',
    categorySlug: 'basejny',
    image: 'https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?w=800',
    rating: 4.6,
    reviewCount: 18,
    inStock: true,
    badge: 'Знижка',
    shortDesc:
      'Надійний каркасний басейн для всієї родини з міцною конструкцією.',
  },
  {
    id: 'pool-inflatable-244',
    name: 'Надувний басейн Easy Set 2.44 м',
    price: 3200,
    category: 'Басейни',
    categorySlug: 'basejny',
    image: 'https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?w=800',
    rating: 4.3,
    reviewCount: 42,
    inStock: true,
    badge: 'Новинка',
    shortDesc: 'Легкий у встановленні надувний басейн для дітей та дорослих.',
  },
  // JACUZZI (Джакузі та крижанні вани)
  {
    id: 'jacuzzi-spa-4person',
    name: 'СПА-басейн гідромасажний на 4 особи',
    price: 89000,
    oldPrice: 99000,
    category: 'Джакузі та крижанні вани',
    categorySlug: 'dzhakuzi-ta-kryzhanni-vany',
    image: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800',
    rating: 4.9,
    reviewCount: 8,
    inStock: true,
    badge: 'Топ',
    shortDesc:
      'Розкішний гідромасажний СПА-басейн з підігрівом та LED-підсвіткою.',
  },
  {
    id: 'ice-bath-portable',
    name: 'Крижанна ванна для загартування портативна',
    price: 12500,
    category: 'Джакузі та крижанні вани',
    categorySlug: 'dzhakuzi-ta-kryzhanni-vany',
    image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800',
    rating: 4.5,
    reviewCount: 15,
    inStock: true,
    badge: 'Новинка',
    shortDesc: 'Компактна крижанна ванна для відновлення після тренувань.',
  },
  // CHEMICALS (Хімія для басейну)
  {
    id: 'chemical-chlorine-5kg',
    name: 'Хлор шоковий у гранулах 5 кг',
    price: 1850,
    category: 'Хімія для басейну',
    categorySlug: 'khimiya-dlya-basejnu',
    image: 'https://images.unsplash.com/photo-1563453392212-326f5e854473?w=800',
    rating: 4.7,
    reviewCount: 56,
    inStock: true,
    badge: 'Хіт продажів',
    shortDesc:
      'Ефективний шоковий хлор для швидкої дезінфекції води в басейні.',
  },
  {
    id: 'chemical-ph-minus',
    name: 'pH-мінус для басейну 3 кг',
    price: 680,
    category: 'Хімія для басейну',
    categorySlug: 'khimiya-dlya-basejnu',
    image: 'https://images.unsplash.com/photo-1585704032915-c3400ca199e7?w=800',
    rating: 4.4,
    reviewCount: 34,
    inStock: true,
    shortDesc: 'Засіб для зниження рівня pH води до оптимального значення.',
  },
  {
    id: 'test-kit',
    name: 'Тестер для води 5-в-1',
    price: 450,
    category: 'Хімія для басейну',
    categorySlug: 'khimiya-dlya-basejnu',
    image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800',
    rating: 4.6,
    reviewCount: 28,
    inStock: true,
    shortDesc:
      'Комплект для тестування pH, хлору, лужності, жорсткості та ціанурової кислоти.',
  },
  // EQUIPMENT (Обладнання для басейну)
  {
    id: 'pump-sand-filter',
    name: 'Пісочний фільтр-насос 6000 л/год',
    price: 8900,
    oldPrice: 10500,
    category: 'Обладнання для басейну',
    categorySlug: 'obladnannya-dlya-basejnu',
    image: 'https://images.unsplash.com/photo-1572331165267-854da2b021aa?w=800',
    rating: 4.8,
    reviewCount: 22,
    inStock: true,
    badge: 'Топ',
    shortDesc: 'Потужний пісочний фільтр для басейнів до 30 м³.',
  },
  {
    id: 'heater-electric',
    name: 'Електричний нагрівач для басейну 3 кВт',
    price: 5600,
    category: 'Обладнання для басейну',
    categorySlug: 'obladnannya-dlya-basejnu',
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800',
    rating: 4.5,
    reviewCount: 14,
    inStock: true,
    shortDesc:
      'Компактний електронагрівач для підтримки комфортної температури води.',
  },
  {
    id: 'vacuum-cleaner',
    name: 'Робот-пилосос для басейну автоматичний',
    price: 15800,
    category: 'Обладнання для басейну',
    categorySlug: 'obladnannya-dlya-basejnu',
    image: 'https://images.unsplash.com/photo-1530549387789-4c1017266635?w=800',
    rating: 4.7,
    reviewCount: 19,
    inStock: false,
    badge: 'Хіт продажів',
    shortDesc: 'Автоматичний робот-пилосос для очищення дна та стінок басейну.',
  },
  // FINISHING (Оздоблювальні матеріали)
  {
    id: 'mosaic-blue',
    name: 'Мозаїка скляна синя 32.7x32.7 см',
    price: 890,
    category: 'Оздоблювальні матеріали',
    categorySlug: 'ozdoblyuvalni-materialy',
    image: 'https://images.unsplash.com/photo-1519046904884-53103b34b206?w=800',
    rating: 4.6,
    reviewCount: 31,
    inStock: true,
    shortDesc: 'Якісна скляна мозаїка для оздоблення басейнів та СПА-зон.',
  },
  {
    id: 'liner-pvc-blue',
    name: 'Плівка ПВХ для басейну блакитна (рулон 25 м²)',
    price: 4200,
    category: 'Оздоблювальні матеріали',
    categorySlug: 'ozdoblyuvalni-materialy',
    image: 'https://images.unsplash.com/photo-1562778612-e1e0cda9915c?w=800',
    rating: 4.4,
    reviewCount: 17,
    inStock: true,
    badge: 'Новинка',
    shortDesc: 'Армована ПВХ плівка для гідроізоляції та оздоблення басейнів.',
  },
  // PIPES (Труби та фітинги)
  {
    id: 'pipe-pvc-50mm',
    name: 'Труба ПВХ для басейну 50 мм (3 м)',
    price: 320,
    category: 'Труби та фітинги',
    categorySlug: 'truby-ta-fitynhy',
    image: 'https://images.unsplash.com/photo-1585704032915-c3400ca199e7?w=800',
    rating: 4.5,
    reviewCount: 45,
    inStock: true,
    shortDesc:
      'Якісна ПВХ труба для систем фільтрації та водопостачання басейну.',
  },
  {
    id: 'fitting-set',
    name: 'Набір фітингів для басейну (20 шт)',
    price: 780,
    category: 'Труби та фітинги',
    categorySlug: 'truby-ta-fitynhy',
    image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800',
    rating: 4.3,
    reviewCount: 23,
    inStock: true,
    shortDesc: "Комплект з'єднувачів, кутів та перехідників для монтажу.",
  },
  // COVERS (Накриття для басейну)
  {
    id: 'cover-round-460',
    name: 'Накриття для круглого басейну 4.6 м',
    price: 2100,
    category: 'Накриття для басейну',
    categorySlug: 'nakryttya-dlya-basejnu',
    image: 'https://images.unsplash.com/photo-1562778612-e1e0cda9915c?w=800',
    rating: 4.5,
    reviewCount: 29,
    inStock: true,
    badge: 'Хіт продажів',
    shortDesc: 'Міцне захисне накриття для каркасних та надувних басейнів.',
  },
  {
    id: 'solar-cover-366',
    name: 'Сонячне накриття для басейну 3.66 м',
    price: 1650,
    category: 'Накриття для басейну',
    categorySlug: 'nakryttya-dlya-basejnu',
    image: 'https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?w=800',
    rating: 4.4,
    reviewCount: 21,
    inStock: true,
    shortDesc: 'Накриття з ефектом нагріву води від сонячного світла.',
  },
  // ACCESSORIES (Аксесуари для басейну)
  {
    id: 'ladder-122',
    name: 'Сходи для басейну 122 см',
    price: 2800,
    category: 'Аксесуари для басейну',
    categorySlug: 'aksesuary-dlya-basejnu',
    image: 'https://images.unsplash.com/photo-1575429198097-0414ec08e8cd?w=800',
    rating: 4.6,
    reviewCount: 38,
    inStock: true,
    shortDesc: 'Надійні металеві сходи з антиковзними ступенями.',
  },
  {
    id: 'thermometer-digital',
    name: 'Термометр для басейну цифровий',
    price: 380,
    category: 'Аксесуари для басейну',
    categorySlug: 'aksesuary-dlya-basejnu',
    image: 'https://images.unsplash.com/photo-1530549387789-4c1017266635?w=800',
    rating: 4.2,
    reviewCount: 52,
    inStock: true,
    shortDesc: 'Точний цифровий термометр з великим дисплеєм.',
  },
  // EMBEDDED (Закладні для басейну)
  {
    id: 'skimmer-standard',
    name: 'Скімер стандартний для бетонного басейну',
    price: 1450,
    category: 'Закладні для басейну',
    categorySlug: 'zakladni-dlya-basejnu',
    image: 'https://images.unsplash.com/photo-1572331165267-854da2b021aa?w=800',
    rating: 4.5,
    reviewCount: 27,
    inStock: true,
    shortDesc: 'Якісний скімер для збору поверхневих забруднень.',
  },
  {
    id: 'return-jet',
    name: 'Форсунка повернення води регульована',
    price: 520,
    category: 'Закладні для басейну',
    categorySlug: 'zakladni-dlya-basejnu',
    image: 'https://images.unsplash.com/photo-1519046904884-53103b34b206?w=800',
    rating: 4.4,
    reviewCount: 19,
    inStock: true,
    shortDesc: 'Регульована форсунка для рівномірного розподілу води.',
  },
  // AQUAFITNESS (Аквафітнес і відпочинок на воді)
  {
    id: 'float-lounger',
    name: 'Надувний шезлонг для басейну',
    price: 890,
    category: 'Аквафітнес і відпочинок на воді',
    categorySlug: 'akvafitnes-i-vidpochynok-na-vodi',
    image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800',
    rating: 4.3,
    reviewCount: 67,
    inStock: true,
    badge: 'Хіт продажів',
    shortDesc: 'Комфортний надувний шезлонг для відпочинку на воді.',
  },
  {
    id: 'aqua-noodle-set',
    name: 'Набір нудлів для аквафітнесу (4 шт)',
    price: 650,
    category: 'Аквафітнес і відпочинок на воді',
    categorySlug: 'akvafitnes-i-vidpochynok-na-vodi',
    image: 'https://images.unsplash.com/photo-1530549387789-4c1017266635?w=800',
    rating: 4.5,
    reviewCount: 34,
    inStock: true,
    shortDesc: 'Яскраві пінопластові нудли для занять аквааеробікою.',
  },
  // SAUNA (Обладнання для саун)
  {
    id: 'sauna-heater-6kw',
    name: 'Піч для сауни електрична 6 кВт',
    price: 12500,
    oldPrice: 14000,
    category: 'Обладнання для саун',
    categorySlug: 'obladnannya-dlya-saun',
    image: 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800',
    rating: 4.8,
    reviewCount: 16,
    inStock: true,
    badge: 'Топ',
    shortDesc: "Потужна електрична піч для сауни об'ємом до 8 м³.",
  },
  {
    id: 'sauna-stones-20kg',
    name: 'Каміння для сауни габро-діабаз 20 кг',
    price: 890,
    category: 'Обладнання для саун',
    categorySlug: 'obladnannya-dlya-saun',
    image: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800',
    rating: 4.6,
    reviewCount: 41,
    inStock: true,
    shortDesc: 'Якісне каміння з високою теплоємністю для парної.',
  },
  // SPARE PARTS (Запчастини)
  {
    id: 'cartridge-filter-a',
    name: 'Картридж для фільтра тип A (2 шт)',
    price: 480,
    category: 'Запчастини',
    categorySlug: 'zapchastyny',
    image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800',
    rating: 4.4,
    reviewCount: 89,
    inStock: true,
    badge: 'Хіт продажів',
    shortDesc: 'Змінні картриджі для фільтр-насосів Intex та Bestway.',
  },
  {
    id: 'repair-kit',
    name: 'Ремонтний набір для надувних виробів',
    price: 180,
    category: 'Запчастини',
    categorySlug: 'zapchastyny',
    image: 'https://images.unsplash.com/photo-1585704032915-c3400ca199e7?w=800',
    rating: 4.2,
    reviewCount: 56,
    inStock: true,
    shortDesc: 'Комплект латок та клею для ремонту надувних басейнів.',
  },
]

export const getProductById = (id: string): Product | undefined => {
  return products.find((p) => p.id === id)
}

export const getProductsByCategory = (categorySlug: string): Product[] => {
  return products.filter((p) => p.categorySlug === categorySlug)
}

export const getBestSellers = (): Product[] => {
  return products.filter((p) => p.badge === 'Хіт продажів').slice(0, 8)
}

export const getRelatedProducts = (
  product: Product,
  limit: number = 4,
): Product[] => {
  return products
    .filter(
      (p) => p.categorySlug === product.categorySlug && p.id !== product.id,
    )
    .slice(0, limit)
}

export const getCrossSellProducts = (productIds: string[]): Product[] => {
  return products.filter((p) => productIds.includes(p.id))
}
